import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {ColumnMode} from '@almaobservatory/ngx-datatable';
import {StickyPopover} from 'asax-common';

@Component({
  selector: 'asax-sky-view-aladin-popover-footprint',
  templateUrl: './aladin-popover-footprint.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [`
    .footprint-publications.ngx-datatable.bootstrap .datatable-body .datatable-body-row .datatable-body-cell {
      font-size: 10px !important;
    }

    .footprint-publications.ngx-datatable.bootstrap .datatable-body .datatable-body-row .datatable-body-group-cell {
      font-size: 10px !important;
    }

    .footprint-publications.ngx-datatable.bootstrap .datatable-header .datatable-header-cell {
      font-size: 9px !important;
    }

    .footprint-publications.ngx-datatable.fixed-row .datatable-scroll .datatable-body-row .datatable-body-cell {
      white-space: normal !important;
    }
  `],
  encapsulation: ViewEncapsulation.None
})
export class AladinPopoverFootprintComponent implements OnChanges {
  readonly height = 180;
  readonly width = 400;
  readonly rowHeight = 120;
  readonly headerHeight = 40;

  @ViewChild('stickyPopover', {static: true}) stickyPopover: StickyPopover;

  @Input() footprint: any;

  ColumnMode = ColumnMode;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.footprint) {
      this.onFootprint();
    }
  }

  close(): void {
    this.stickyPopover?.close();
  }

  closeWithTimeout(): void {
    this.stickyPopover?.closeWithTimeout();
  }

  private onFootprint(): void {
    if (this.footprint) {
      this.stickyPopover?.open();
    } else {
      this.stickyPopover?.close();
    }
  }

  getLonLatInterval(lonValue: number, latValue: number): string {
    const lonValueToDisplay = lonValue.toFixed(6);
    const latValueToDisplay = latValue.toFixed(6);

    return lonValueToDisplay + ' ' + latValueToDisplay;
  }
}
